import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withMobileDialog } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import {
  getEventTemplate,
  resetEventTemplate,
} from '@pingum/app-state-management/eventTemplate/actions';

import Page from '../../widgets/Page';
import { getQueryParam } from '../../../utils/urlHelper';
import EventTemplateEditor from './components/EventTemplateEditor';

export class EventTemplateSettingsComponent extends React.Component {
  constructor(props) {
    super(props);

    const id = getQueryParam('copy') || props.history.location.pathname.replace(/^\/settings\/workflows[/]?/, '').replace(/\/{0,1}\?.*/g, '');

    if (id && id !== 'new') {
      props.getEventTemplate(id);
      // this.props.getEventNotificationsForEvent(id);
    } else {
      props.resetEventTemplate();
    }
  }

  render() {
    const {
      selectedEventTemplate,
      isLoading,
    } = this.props;
    const {
      id,
      ...eventTemplateCopy
    } = selectedEventTemplate;

    const isCopy = !!getQueryParam('copy');

    if (!id) {
      return (
        <Page title="Workflow Details" showLoadingIndicator={isLoading}>
          <EventTemplateEditor
            toggleAddEditEventTemplateEditor={this.toggleAddEditEventTemplateEditor}
            isLoading={isLoading}
            eventTemplate={{
              name: '',
              description: '',
              eventData: [],
              tags: [],
              allowActiveDuplicates: true,
              eventDataDefaultValues: {},
              workflowStatuses: [],
              configurableTags: true,
              configurableName: true,
              configurableStartStatus: true,
              defaultStartStatus: {
                id: 0,
                name: 'Select A Value...',
                icon: 'search',
                iconColor: 'gray',
              },
            }}
          />
        </Page>
      );
    }

    return (
      <Page title="Workflow Details" showLoadingIndicator={isLoading}>
        <EventTemplateEditor
          toggleAddEditEventTemplateEditor={this.toggleAddEditEventTemplateEditor}
          isLoading={isLoading}
          eventTemplate={
            id && isCopy
              ? eventTemplateCopy
              : selectedEventTemplate
          }
        />
      </Page>
    );
  }
}

EventTemplateSettingsComponent.propTypes = {
  history: PropTypes.object,
  getEventTemplate: PropTypes.func,
  selectedEventTemplate: PropTypes.object,
  resetEventTemplate: PropTypes.func,
  isLoading: PropTypes.bool,
  eventData: PropTypes.array,
};

EventTemplateSettingsComponent.defaultProps = {
  history: { location: { pathname: '' } },
  getEventTemplate: () => {},
  selectedEventTemplate: {},
  resetEventTemplate: () => {},
  isLoading: false,
  eventData: [],
};

export const mapStateToProps = (state) => ({
  isFetchingEventTemplates: state.eventTemplate.isFetchingEventTemplates,
  eventTemplates: state.eventTemplate.eventTemplatesPageable,
  selectedEventTemplate: state.eventTemplate.eventTemplate,
  isLoading:
    state.eventTemplate.isFetchingEventTemplate
      || state.status.isFetchingStatuses
      || state.eventData.isFetchingEventData
      || state.tag.isFetchingTag
      || state.tagType.isFetchingTagTypes,
  eventData: state.eventData.eventData,
});

export const mapDispatchToProps = (dispatch) => ({
  getEventTemplate: (id) => dispatch(getEventTemplate(id)),
  resetEventTemplate: () => dispatch(resetEventTemplate()),
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(withMobileDialog({ breakpoint: 'sm' })(EventTemplateSettingsComponent)));
